import { required } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  name: {},
  code: '',
  order: ''
};

export default {
  name: 'ConfigConstantsEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      elname: ''
    }
  },
  validations: {
    editEl: {
      name: { required },
      code: { required },
      order: { }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.constants.' + this.elname + '.edit');
      }
      return this.$t('menu.config.constants.' + this.elname + '.new');
    }
  },
  methods: {
    show (elData, elname) {
      this.elname = elname;
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const self = this;
        this.ApiRequest.request('config/edit/' + self.elname, this.ApiRequest.REQUEST_POST, { item: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self, { 'item.code': 'general.item.code' });
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
